import { render, staticRenderFns } from "./index.bak.vue?vue&type=template&id=61e03c5a&scoped=true&"
import script from "./index.bak.vue?vue&type=script&lang=js&"
export * from "./index.bak.vue?vue&type=script&lang=js&"
import style0 from "./index.bak.vue?vue&type=style&index=0&id=61e03c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e03c5a",
  null
  
)

export default component.exports